import { dataStructure, UncastedDataStructure } from '@goldwasserexchange/oblis-frontend-utils';
import ouiBase from '@goldwasserexchange/oui';
import ouiStyle from '@goldwasserexchange/oui-style';
import ouiDom from '@goldwasserexchange/oui-dom';
import { Trans } from '@lingui/macro';
import * as React from 'react';
import { useHookstate } from '@hookstate/core';
import { Spinner } from './spinner';
import { useSubmitNewsletter } from './hooks';
import { useLinguiLocale } from '../../../../../useLinguiLocale';

export const SubmitButton = () => {
  const locale = useLinguiLocale();
  const currentUserIndex = dataStructure.T_ADD.fields.CURRENT.hooks.useCurrentUserIndex();
  const valueState = ouiBase.Form.useFormData<UncastedDataStructure>();
  const firstNameState = useHookstate(valueState.onboarding.users[currentUserIndex].FIRSTNAME);
  const lastNameState = useHookstate(valueState.onboarding.users[currentUserIndex].NAME_1);
  const emailState = useHookstate(valueState.onboarding.users[currentUserIndex].PHONE[0].PHONE);
  const [submit, loading, error, submitted] = useSubmitNewsletter(locale);
  return !(submitted && !loading && error === undefined)
    ? (
      <>
        <ouiDom.Button.Button
          type="button"
          onClick={() => submit({
            firstName: firstNameState,
            lastName: lastNameState,
            email: emailState,
          })}
          fontSize="m"
          fontWeight={ouiStyle.Constants.FontWeightProp.bold}
          color={ouiStyle.Constants.Colors.inverted}
          backgroundColor={ouiStyle.Constants.Colors.primary}
          borderColor={ouiStyle.Constants.Colors.transparent}
          hoverBackgroundColor={ouiStyle.Constants.Colors.primaryShaded}
          marginHorizontal="auto"
          marginVertical="simple"
        >
          {
            !loading
              ? (
                <Trans>
                  Inscription Newsletter
                </Trans>
              )
              : <Spinner />
          }
        </ouiDom.Button.Button>
        {error && (
          <ouiDom.P.P
            color={ouiStyle.Constants.Colors.danger}
            backgroundColor={ouiStyle.Constants.Colors.dangerLigther}
            paddingHorizontal="simple"
          >
            <Trans>
              Une erreur s'est produite, veuillez réessayer plus tard
            </Trans>
          </ouiDom.P.P>
        )}
      </>
    ) : (
      <ouiDom.P.P
        color={ouiStyle.Constants.Colors.success}
        backgroundColor={ouiStyle.Constants.Colors.successLigther}
        paddingHorizontal="simple"
      >
        <Trans>
          Inscription à la newsletter réussie!
        </Trans>
      </ouiDom.P.P>
    );
};
